import { ITerm } from './index';

const TERM_SCRAP_NHIS_LIST: ITerm[] = [
  {
    text: '(필수) 개인(신용)정보 제3자 제공 동의(건강보험 스크래핑)',
    guideText: '',
    required: true,
    termCd: '',
    type: 'term',
    path: '/terms/SCRAP_NHIS_1.html',
    subTextItem: [],
  },
  {
    text: '(필수) 개인(신용)정보 수집·이용 동의(건강보험 스크래핑)',
    guideText: '',
    required: true,
    termCd: '',
    type: 'term',
    path: '/terms/SCRAP_NHIS_2.html',
    subTextItem: [],
  },
];

export default TERM_SCRAP_NHIS_LIST;
